import React from "react";
import { isValNull } from "../../../utils/index";
import Table from "../../Common/Table/index";
import styled from "styled-components";
import Share from "sushiweb/Icons/all/Share";
import { FlexContainer } from "../../../constants/assets/containers";
import { Tooltip } from "@material-ui/core";
import { getDashboardUrl } from "../../../views/Home";

const tableFields = [
  {
    heading: "Detail",
    key: "key",
  },
  {
    heading: "Value",
    key: "value",
  },
];

const EstimatedDetails = (props) => {
  const { estimated_trip_details } = props;
  if (isValNull(estimated_trip_details)) {
    return <p>Details of estimated earning are not available</p>;
  }
  const getActiveElemnt = (item, key) => {
    if (
      (item["key"] === "pickup_distance" || item["key"] === "drop_distance") &&
      key === "value"
    ) {
      return item[key] + " km";
    }

    if (item["key"] === "earning" && key === "value") {
      return "₹ " + item[key];
    }
    return item[key];
  };

  return (
    <FlexContainer justify={"flex-start"} align={"flex-start"}>
      {estimated_trip_details.map((item, index) => {
        let estimatedDetailArray = [];
        if (item.estimated_details) {
          estimatedDetailArray = Object.keys(item.estimated_details).map(
            (key) => ({ key: key, value: item.estimated_details[key] })
          );
        }
        return (
          <EstimatedDetailCard>
            <FlexContainer>
              <Tooltip
                title={"Click to open Trip Statistics"}
                arrow
                placement="top"
                followCursor
              >
                <TripStatistics
                  onClick={() =>
                    window.open(
                      getDashboardUrl() +
                        `/admin/trip_statistics_new?delivery_trip_id=${item.delivery_trip_id}`,
                      "_blank"
                    )
                  }
                >
                  {/* change here for trip statistics link */}
                  Trip ID: {item.delivery_trip_id}{" "}
                  {item.flow_type === "BACKWARD"
                    ? "(" + item.flow_type + ")"
                    : ""}
                </TripStatistics>
              </Tooltip>
            </FlexContainer>
            {estimatedDetailArray && estimatedDetailArray.length ? (
              <Table
                fields={tableFields}
                list={estimatedDetailArray}
                getFieldValue={getActiveElemnt}
              />
            ) : (
              <p>Estimated details are not available.</p>
            )}
          </EstimatedDetailCard>
        );
      })}
    </FlexContainer>
  );
};

export default EstimatedDetails;
const EstimatedDetailCard = styled.div`
  margin: 10px;
  width: 50%;
`;

const TripStatistics = styled.div`
  color: blue;
  cursor: pointer;
  text-decoration: underline;
`;
